import { BrowserRouter, Route, Routes, useLocation, useNavigate } from "react-router-dom";
import "./App.css";
import "./BombaStyle.css";
import "./fonts.css";
import "./Responsive.css";
import LoginScreen from "./components/LoginScreen";
import Dashboard from "./components/Dashboard";
import GamePlay from "./components/GamePlay";
// new import
import HalloweenBombaGame from "./components/wrapper/HalloweenBombaGame";

import RegisterScreen from "./components/RegisterScreen";
import { BLAUTHTOKEN, getDataFromStore } from "./utils/CookiesUtils";
import { Toaster } from "react-hot-toast";
import GuestWrapper from "./components/wrapper/GuestWrapper";
import AuthWrapper from "./components/wrapper/AuthWrapper";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import StrawberriesBonus from "./components/StrawberriesBonus";
import CoinContainer from "./components/CoinContainer";
import { PersonalData } from "./components/PersonalData";
import Withdraw from "./components/Withdraw";
import Deposit from "./components/Deposit";
import Password_Security from "./components/Password_Security";
import Account_Statement from "./components/Account_Statement";
import Home from "./components/Home";
import { BalanceProvider } from "./BalanceContext";
import GamePlayBomba from "./components/GamePlayBomba";
import LoadingScreen from "./components/ice-game/LoadingScreen";
import MenuScreen from "./components/ice-game/MenuScreen";
import HalloweenIceGame from "./components/wrapper/HalloweenIceGame";
import TvMillionarioGame from "./components/wrapper/TvMillionarioGame";
import JackpotGamePreview from "./components/tv-millionario/JackpotGamePreview";



// Routes that bring their own full-screen background — the Halloween gameplay
// image must not even be requested on these.
const NO_GAMEPLAY_BG_ROUTES = ["/halloween-ice"];

// Rendered inside the router so it can drop the <img> entirely on those routes.
function GameplayBg() {
    const { pathname } = useLocation();
    if (NO_GAMEPLAY_BG_ROUTES.includes(pathname)) return null;
    return <img className="gameplay-bg" src="/assets/img/gameplay.png" alt="" />;
}

function App() {
    const token = getDataFromStore(BLAUTHTOKEN);

    function RequireAuth() {
        const navigate = useNavigate();

        return token ? <Dashboard /> : <LoginScreen />;
    }
    const toastDefaultOptionsStyle = {
        borderRadius: "5px",
        fontSize: "14px",
    };

    return (
        <BalanceProvider>
            <BrowserRouter>
                <GameplayBg />
                <div className="wrapper-body">
                    {/* <CoinContainer/> */}
                    <Routes>
                        {/* dev only: the TV JACKPOT GAME bonus on its own, no login */}
                        {process.env.NODE_ENV === "development" && (
                            <Route path="/tv-jackpot-bonus" element={<JackpotGamePreview />} />
                        )}
                        <Route element={<GuestWrapper />}>
                            <Route path="/login" element={<LoginScreen />} />
                            <Route path="/register" element={<RegisterScreen />} />
                        </Route>

                        <Route element={<AuthWrapper />}>
                            <Route path="/" element={<Dashboard />}>
                                <Route index element={<Home />}></Route>
                                <Route path="personal-data" element={<PersonalData />}></Route>
                                <Route path="withdraw" element={<Withdraw />}></Route>
                                <Route path="deposit" element={<Deposit />}></Route>
                                <Route path="account-statement" element={<Account_Statement />}></Route>
                                <Route path="password-security" element={<Password_Security />}></Route>
                            </Route>
                            <Route path="/gameplay" element={<GamePlay />} />
                            {/* new route */}
                            <Route path="/halloween-bomba" element={<HalloweenBombaGame />} />
                            <Route path="/halloween-ice" element={<HalloweenIceGame />} />
                            <Route path="/gameplay-bomba" element={<GamePlayBomba />} />
                            <Route path="/loading-screen" element={<LoadingScreen />} />
                            <Route path="/ice-menu" element={<MenuScreen />} />
                            <Route path="/StrawberriesBonus" element={<StrawberriesBonus />} />
                            <Route path="/tv-millionario" element={<TvMillionarioGame />} />
                            {/* <Route path="/PumpkinBonus" element={<PumpkinBonus />} /> */}
                            {/* <Route path="/CauldronBonus" element={<CauldronBonus />} /> */}
                        </Route>
                    </Routes>
                </div>
            </BrowserRouter>
            <Toaster
                toastOptions={{
                    duration: 2000,
                    style: toastDefaultOptionsStyle,
                }}
            />
        </BalanceProvider>
    );
}

export default App;
